import React from "react";
import { ctaClickEvent } from "../services/adobeDataLayer";

function Header() {
  return (
    <header className="d-flex align-items-center">
      <a href="">
        <img
          src="./dist/img/icici_logo.webp"
          alt="ICICI Bank Logo"
          width={252}
          height={50}
          className="img-fluid"
          onClick={() => {
            ctaClickEvent("logo: ICICI Bank", "header", "icon", 0, "na");
          }}
        />
      </a>
      <h2>Land Loans</h2>
    </header>
  );
}

export default Header;
